var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.fareFeatures.features),function(feature,index){return (_vm.fareFeatures)?_c('v-chip',{key:index,staticStyle:{"text-align":"center","padding":"6px"},attrs:{"justify-center":""}},[_vm._v("\n        "+_vm._s(feature)+"\n      ")]):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }